import { cn } from '@/lib/utils';

interface SelectableTableRowProps {
  children: React.ReactNode;
  isSelected?: boolean;
  isExpanded?: boolean;
  isEditing?: boolean;
  onClick?: () => void;
  index?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Reusable table row with consistent styling for selection, expansion, and editing states
 * Handles alternating row colors, hover states, and click behavior
 */
export function SelectableTableRow({
  children,
  isSelected = false,
  isExpanded = false,
  isEditing = false,
  onClick,
  index = 0,
  className,
  style
}: SelectableTableRowProps) {
  return (
    <tr
      onClick={onClick}
      style={style}
      className={cn(
        'border-b last:border-b-0 hover:bg-muted/30 transition-colors',
        // Alternating row colors
        index % 2 === 0 ? 'bg-background' : 'bg-muted/10',
        // Selected state
        isSelected && 'bg-blue-50 dark:bg-blue-950/20',
        // Expanded state (no bottom border to connect with detail row)
        isExpanded && 'border-b-0',
        // Editing state
        isEditing && 'bg-blue-50/50 dark:bg-blue-950/20',
        // Cursor
        !isEditing && onClick && 'cursor-pointer',
        className
      )}
    >
      {children}
    </tr>
  );
}
